import { render, staticRenderFns } from "./LomALta.vue?vue&type=template&id=0a3df402"
import script from "./LomALta.vue?vue&type=script&lang=js"
export * from "./LomALta.vue?vue&type=script&lang=js"
import style0 from "./LomALta.vue?vue&type=style&index=0&id=0a3df402&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports